import React, { Fragment, useEffect, useState } from "react";
import { Alert, Backdrop, CircularProgress, Container } from "@mui/material";
import PaymentCreditCardOnCollection from "../../components/PaymentCreditCardOnCollection";
import {
	ApiCallStatus,
	PaymentMethod, PaymentType
} from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
	createCreditCardOnCollectionPaymentData,
	fetchPaymentOrderData
} from "../PageFunctions/paymentFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";


const PaymentCreditCardOnCollectionPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [paymentOrderInfo, setPaymentOrderInfo] = useState(null);
	const [paymentErrorMessage, setPaymentErrorMessage] = useState("");

	const [paymentOrderInfoCallStatus, setPaymentOrderInfoCallStatus] = useState(ApiCallStatus.NotStarted);
	const [createCreditCardOnCollectionPaymentCallStatus, setCreateCreditCardOnCollectionPaymentCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoOrderConfirmationPage = (orderId) => navigate(`/order-confirmation/${orderId}`);

	const gotoLoginPage = () => {
		return navigate("/login", {state: {from: location}});
	};



	const fetchPaymentOrderDataAsync = async () => {
		await fetchPaymentOrderData({
			paymentType: PaymentType.CreditCardOnCollection,
			setPaymentOrderInfo,
			setStatusInProgress: () => setPaymentOrderInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Error)
		});
	};

	const createCreditCardOnCollectionPaymentDataAsync = async () => {
		setPaymentErrorMessage("");
		await createCreditCardOnCollectionPaymentData({
			setStatusInProgress: () => setCreateCreditCardOnCollectionPaymentCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setCreateCreditCardOnCollectionPaymentCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setCreateCreditCardOnCollectionPaymentCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setCreateCreditCardOnCollectionPaymentCallStatus(ApiCallStatus.Error),
			setErrorMessage: setPaymentErrorMessage
		});
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await fetchPaymentOrderDataAsync();
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (createCreditCardOnCollectionPaymentCallStatus === ApiCallStatus.Succeeded && !!paymentOrderInfo?.orderId) {
			gotoOrderConfirmationPage(paymentOrderInfo.orderId);
		}
	}, [createCreditCardOnCollectionPaymentCallStatus, paymentOrderInfo]);

	useEffect(() => {
		// if (!!paymentErrorMessage) window.scrollTo(0, 0);
	}, [paymentErrorMessage]);

	const allLoadingStates = [
		paymentOrderInfoCallStatus,
		createCreditCardOnCollectionPaymentCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			{!!paymentErrorMessage && (
				<Alert severity="warning" sx={{mt: 2, mb: 2}}>
					{paymentErrorMessage}
				</Alert>
			)}
			<PaymentCreditCardOnCollection
				paymentOrderInfo={paymentOrderInfo}
				onSubmit={createCreditCardOnCollectionPaymentDataAsync}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default PaymentCreditCardOnCollectionPage;
